import React, { useState, useCallback } from "react";
import { useIntl } from "react-intl";
import { Row, Col } from "antd";

import ImportForm from "./importForm";
import ImportResult from "./importResult";
import { warn } from "../../../modules/messages";
import UploadFile from "../../app/generic/uploadFile";
import ImportInstructions from "../importInstructions";
import { postForm } from "../../../modules/httpFunctions";

const defaultAccept =
  ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";

function ImportFile({
  entity,
  children,
  filePrefix,
  whatFourth,
  showColliDelimiter,
}) {
  const intl = useIntl();
  const [importForm, setImportForm] = useState();
  const saveImportFormRef = useCallback((formRef) => {
    setImportForm(formRef);
  }, []);

  const [importDefaultSetting, setImportDefaultSetting] = useState(
    JSON.parse(localStorage.getItem(`${entity}_import_setting`)) || {
      delimiter: intl.formatMessage({
        id: "import.firstDelimiter",
        defaultMessage: "středník",
      }),
      containHeader: true,
      colliDelimiter: ";",
      worksheetNumber: 1,
      fileType: "csv",
      encoding: 65001,
    }
  );
  const handleImportSettingChange = useCallback(
    (values) => {
      const setting = { ...importDefaultSetting, ...values };
      localStorage.setItem(`${entity}_import_setting`, JSON.stringify(setting));
      setImportDefaultSetting(setting);
    },
    [entity, importDefaultSetting]
  );

  const [resultData, setResultData] = useState();
  const onSendFile = useCallback(
    ({ file, filename, onError, onProgress, onSuccess }) => {
      return importForm.validateFields((err, values) => {
        if (!err) {
          handleImportSettingChange(values);

          const formData = new FormData();
          formData.append(filename, file);
          Object.keys(values).forEach((key) => {
            formData.append(key, values[key]);
          });
          postForm(
            `${entity}/import`,
            formData,
            true,
            ({ total, loaded }) => {
              onProgress({ percent: Math.round((loaded / total) * 100) }, file);
            },
            360000
          )
            .then(({ data: response }) => {
              setModalVisible(
                response.importResults && response.importResults.length > 0
              );
              setResultData(response);
              onSuccess(response, file);
            })
            .catch(onError);
        }
        return {
          abort() {
            warn(
              intl.formatMessage({
                id: "import.uploadAborted",
                defaultMessage: "Nahrávání bylo zrušeno!",
              })
            );
          },
        };
      });
    },
    [intl, entity, importForm, handleImportSettingChange]
  );

  const [modalVisible, setModalVisible] = useState();
  const handleModalClose = useCallback(() => {
    setModalVisible(false);
    setTimeout(() => setResultData(), 1000);
  }, []);

  return (
    <Row type="flex" justify="center" gutter={[0, 50]}>
      <Col sm={24} xxl={18}>
        <Row>
          <Col>
            <Row gutter={[0, 100]}>
              <Col>
                <ImportResult
                  entity={entity}
                  visible={modalVisible}
                  whatFourth={whatFourth}
                  resultData={resultData}
                  onClose={handleModalClose}
                />
                <ImportForm
                  ref={saveImportFormRef}
                  showColliDelimiter={showColliDelimiter}
                  importDefaultSetting={importDefaultSetting}
                />
                <UploadFile
                  showSuccess={false}
                  accept={defaultAccept}
                  requestMethod={onSendFile}
                  fileRestriction={intl.formatMessage({
                    id: "import.supportedFormats",
                    defaultMessage: "Podporované formáty jsou csv a xlsx.",
                  })}
                />
              </Col>
            </Row>
            {/* {entity === "consignment" && (
              <Row gutter={[0, 40]}>
                <Col>
                  <Typography.Title level={4} className="center">
                    {intl.formatMessage({
                      id: "import.message",
                      defaultMessage:
                        "Aktualizujte si prosím šablonu, došlo k přidání ADR atributů a stohovatelnosti kusů, děkujeme.",
                    })}
                  </Typography.Title>
                </Col>
              </Row>
            )} */}
            <ImportInstructions filePrefix={filePrefix || entity}>
              {children}
            </ImportInstructions>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default ImportFile;
